import(/* webpackMode: "eager" */ "/vercel/path0/apps/client/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/client/components/PostHogProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/packages/ui/src/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider","useToast","toast"] */ "/vercel/path0/packages/ui/src/toast.tsx");
